import Vue from 'vue'
import dayjs from 'dayjs'

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('dtm', (value) => {
  if (!value) return ''
  return dayjs(value).format('DD MMM YYYY HH:mm')
})

Vue.filter('dateOnly', (value) => {
  if (!value) return ''
  return dayjs(value).format('DD MMM YYYY')
})

Vue.filter('time', (value) => {
  if (!value) return ''
  return dayjs(value).format('HH:mm')
})

Vue.filter('curr', (value) => {
  if (!value) return '0'
  let s = Math.floor(value).toString()
  let i = s.length % 3
  let h = i > 0 ? (s.slice(0, i) + (s.length > 3 ? '.' : '')) : ''
  return h + s.slice(i).replace(/(\d{3})(?=\d)/g, '$1.')
})